import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import ProductGrid from '../components/products/ProductGrid.jsx';
import ProductFilter from '../components/products/ProductFilter.jsx';
import ProductSort from '../components/products/ProductSort.jsx';
import { productService } from '../services/productService';

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, total: 0, pages: 1 });
  const [filters, setFilters] = useState({
    brand: '',
    category: '',
    minPrice: '',
    maxPrice: '',
    ram: '',
    storage: '',
    condition: '',
    search: '',
    sortBy: 'newest',
  });
  
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParams = {
      brand: params.get('brand') || '',
      category: params.get('category') || '',
      search: params.get('search') || '',
      minPrice: params.get('minPrice') || '',
      maxPrice: params.get('maxPrice') || '',
      ram: params.get('ram') || '',
      storage: params.get('storage') || '',
      condition: params.get('condition') || '',
      sortBy: params.get('sortBy') || 'newest',
      page: parseInt(params.get('page')) || 1,
    };
    setFilters(prev => ({ ...prev, ...searchParams }));
    fetchProducts(searchParams);
  }, [location.search]);

  const fetchProducts = async (params) => {
    setLoading(true);
    try {
      const response = await productService.getProducts(params);
      setProducts(response.data);
      setPagination(response.pagination);
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  const updateFilters = (newFilters) => {
    // Reset page to 1 whenever any filter (other than page itself) changes
    const isPageChange = Object.keys(newFilters).length === 1 && 'page' in newFilters;
    const mergedFilters = { ...filters, ...newFilters };
    if (!isPageChange) {
      mergedFilters.page = 1;
    }
    const params = new URLSearchParams();
    Object.keys(mergedFilters).forEach(key => {
      const value = mergedFilters[key];
      // Include the param if it has a real value (allow 0 for prices)
      if (value !== '' && value !== null && value !== undefined) {
        params.set(key, value);
      }
    });
    navigate(`/products?${params.toString()}`);
  };

  return (
    <div className="py-8">
      <div className="container-custom">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">All Products</h1>
          <p className="text-gray-600 dark:text-gray-400">
            Discover our collection of premium smartphones and accessories
          </p>
        </div>
        
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Filters Sidebar */}
          <div className="lg:col-span-1">
            <ProductFilter filters={filters} onFilterChange={updateFilters} />
          </div>
          
          {/* Products Grid */}
          <div className="lg:col-span-3">
            <ProductSort 
              currentSort={filters.sortBy} 
              onSortChange={(sort) => updateFilters({ sortBy: sort })}
              totalProducts={pagination.total}
            />
            <ProductGrid 
              products={products} 
              loading={loading} 
              pagination={pagination}
              onPageChange={(page) => updateFilters({ page })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;